<div class="max-w-5xl mx-auto mt-10 px-4">

  <h2 class="text-2xl font-bold mb-6">My Orders</h2>

  <div *ngIf="loading" class="text-center text-gray-600">Loading...</div>

  <div *ngIf="!loading && orders.length === 0" class="text-center text-gray-400">
    No orders found.
  </div>

  <div class="space-y-4">
    <div *ngFor="let order of orders"
         class="border rounded-lg p-4 bg-white shadow-sm flex justify-between items-center">

      <div>
        <p class="text-lg font-semibold">Order #{{ order.orderId }}</p>
        <p class="text-sm text-gray-500">Placed on: {{ order.date | date }}</p>
        <p class="text-sm font-medium mt-1">Total: ৳ {{ order.total }}</p>
        <span class="mt-1 inline-block text-sm px-2 py-1 rounded text-white"
              [ngClass]="{
                'bg-blue-600': order.status === 'Processing',
                'bg-yellow-500': order.status === 'Pending',
                'bg-green-600': order.status === 'Shipped',
                'bg-purple-600': order.status === 'Delivered'
              }">
          {{ order.status }}
        </span>
      </div>

      <button (click)="track(order.orderId)"
              class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded">
        Track Order
      </button>

    </div>
  </div>

</div>
